var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-37882798"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "columns mb-0" };
const _hoisted_2 = { class: "column horizontal mb-4" };
const _hoisted_3 = { class: "subtitle mb-4" };
const _hoisted_4 = {
    key: 0,
    class: "mt-2 mb-4"
};
const _hoisted_5 = {
    key: 0,
    class: "ml-5 pb-5"
};
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "column" }, null, -1));
const _hoisted_7 = {
    key: 0,
    class: "column is-narrow tabs is-toggle is-small mb-3"
};
const _hoisted_8 = { style: { "justify-content": "right" } };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = {
    class: "column p-0",
    style: { "flex-grow": "0.65" }
};
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabs is-boxed is-small mb-4" }, [
    /*#__PURE__*/ _createElementVNode("ul", null, [
        /*#__PURE__*/ _createElementVNode("li", { class: "is-active" }, [
            /*#__PURE__*/ _createElementVNode("a", { style: { "cursor": "default" } }, [
                /*#__PURE__*/ _createElementVNode("strong", null, "Open Tasks")
            ])
        ])
    ])
], -1));
const _hoisted_12 = { style: { "min-height": "6rem" } };
const _hoisted_13 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "tabs is-boxed is-small mb-4 mt-5" }, [
    /*#__PURE__*/ _createElementVNode("ul", null, [
        /*#__PURE__*/ _createElementVNode("li", { class: "is-active" }, [
            /*#__PURE__*/ _createElementVNode("a", { style: { "cursor": "default" } }, [
                /*#__PURE__*/ _createElementVNode("strong", null, "Completed Tasks")
            ])
        ])
    ])
], -1));
const _hoisted_15 = { style: { "min-height": "6rem" } };
const _hoisted_16 = {
    key: 0,
    class: "noneFound ml-4"
};
const _hoisted_17 = {
    key: 0,
    class: "column p-0"
};
const _hoisted_18 = {
    key: 0,
    class: "box noTaskHighlightedPanel p-3"
};
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("article", { class: "media" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "media-content" }, [
        /*#__PURE__*/ _createElementVNode("div", { class: "content" }, [
            /*#__PURE__*/ _createElementVNode("div", null, "Select a task on the left to view detail")
        ])
    ])
], -1));
const _hoisted_20 = [
    _hoisted_19
];
const _hoisted_21 = { class: "columns is-mobile" };
const _hoisted_22 = { class: "columns is-mobile" };
const _hoisted_23 = { class: "column" };
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("label", { class: "label" }, "Description", -1));
const _hoisted_25 = ["disabled"];
import { doApiAction } from "@/core/api";
import { onMounted, onUnmounted, ref, computed } from "vue";
import { TaskStatus, isTaskAssignedToMe } from "@/core/model";
import TaskWidget from "./TaskWidget.vue";
import TaskDetailPanel from "./TaskDetailPanel.vue";
import { useAsync } from "@/composables/useAsync";
import { refreshMyAssignedTasks } from "@/core/session";
export default /*#__PURE__*/ _defineComponent({
    __name: 'TaskSection',
    props: {
        getTasks: { type: Function },
        addTask: { type: Function },
        title: {},
        subtitle: {},
        showEntityLink: { type: Boolean },
        allowShowAll: { type: Boolean }
    },
    setup(__props) {
        const props = __props;
        const tasks = useAsync();
        const highlightedTask = ref(null);
        const detailOffset = ref(0);
        const itemListingWrapper = ref(null);
        const activeCategory = ref("MINE");
        const compareTasks = (a, b) => {
            if (a.dueAt && b.dueAt)
                return a.dueAt - b.dueAt;
            if (a.dueAt)
                return -1;
            if (b.dueAt)
                return 1;
            return a.createdAt - b.createdAt;
        };
        const closedStatuses = [TaskStatus.COMPLETED, TaskStatus.CANCELLED];
        const openTasks = computed(() => {
            if (tasks.status != 'ready')
                return [];
            const sorted = tasks.data.filter(task => {
                return !closedStatuses.includes(task.status) && (activeCategory.value == "ALL" || isTaskAssignedToMe(task));
            });
            return sorted.sort(compareTasks);
        });
        const completedTasks = computed(() => {
            if (tasks.status != 'ready')
                return [];
            const sorted = tasks.data.filter(task => {
                return closedStatuses.includes(task.status) && (activeCategory.value == "ALL" || isTaskAssignedToMe(task));
            });
            return sorted.sort(compareTasks);
        });
        const highlightTask = (task, elem) => {
            highlightedTask.value = task;
            // Determine offset for detail panel so it aligns vertically
            while (!elem.classList.contains("taskWidget")) {
                if (!elem.parentElement)
                    break;
                elem = elem.parentElement;
            }
            detailOffset.value = elem.offsetTop - itemListingWrapper.value.offsetTop;
            // Update URL query params, so if the user shares a link while a task is highlighted, we can restore it
            const url = new URL(window.location.toString());
            if (task) {
                url.searchParams.set('taskId', task.id.toString());
            }
            else {
                url.searchParams.delete('taskId');
            }
            window.history.replaceState({}, '', url);
        };
        onMounted(() => {
            tasks.fetch(props.getTasks(), "Failed to load tasks")
                .then((tasks) => {
                // Pre-select a task, if the '?taskId=xxx' query parameter is set
                const url = new URL(window.location.toString());
                if (!url.searchParams.has('taskId'))
                    return;
                const taskId = url.searchParams.get('taskId');
                for (let task of tasks) {
                    if (task.id.toString() == taskId) {
                        highlightedTask.value = task;
                        return;
                    }
                }
            });
            if (props.allowShowAll) {
                activeCategory.value = "ALL";
            }
        });
        onUnmounted(() => {
            // Clear taskId query param
            const url = new URL(window.location.toString());
            if (url.searchParams.has('taskId')) {
                url.searchParams.delete('taskId');
                window.history.replaceState({}, '', url);
            }
        });
        const onTaskUpdated = (task) => {
            var _a;
            // When highlighted task is modified by TaskDetailPanel, a new object is returned.
            // We need to overwrite the same task in the task list with the updated reference...
            if (((_a = highlightedTask.value) === null || _a === void 0 ? void 0 : _a.id) == task.id) {
                highlightedTask.value = task;
            }
            for (let i = 0; i < tasks.data.length; ++i) {
                if (tasks.data[i].id == task.id) {
                    tasks.data[i] = task;
                }
            }
            refreshTasksInBackground();
        };
        const refreshTasksInBackground = () => {
            // And also trigger an update of the global task cache,
            // So the little red task indicators will be updated...
            refreshMyAssignedTasks();
            // And check for new tasks on this entity,
            // in case updating this task resulted in the automatic creation of any new tasks
            props.getTasks().then((ts) => {
                var _a;
                tasks.data = ts;
                // Restore highlighted task
                for (let task of tasks.data) {
                    if (task.id == ((_a = highlightedTask.value) === null || _a === void 0 ? void 0 : _a.id)) {
                        highlightedTask.value = task;
                    }
                }
            });
        };
        // Create task modal
        const createTaskModalActive = ref(false);
        const newTaskAudience = ref("PARTNER_USER");
        const newTaskText = ref("");
        const audienceTypes = {
            "Mini City Admin": "NETWORK_USER",
            "Caseworker": "PARTNER_USER"
        };
        const inProgressAction = ref(null);
        const onAddTaskClicked = () => {
            const text = newTaskText.value.trim();
            if (text.length == 0)
                return;
            doApiAction(inProgressAction, "addTask", "Task added", "Failed to add task", () => __awaiter(this, void 0, void 0, function* () {
                const newTask = yield props.addTask(newTaskAudience.value, text);
                tasks.data.push(newTask);
                refreshTasksInBackground();
                createTaskModalActive.value = false;
                newTaskText.value = "";
            }));
        };
        return (_ctx, _cache) => {
            const _component_SaveButton = _resolveComponent("SaveButton");
            const _component_LoadingSpinner = _resolveComponent("LoadingSpinner");
            const _component_FormSelectField = _resolveComponent("FormSelectField");
            const _component_ModalDialog = _resolveComponent("ModalDialog");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.title ? _ctx.title : 'Tasks'), 1),
                                (_ctx.subtitle)
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            (_ctx.addTask && _unref(tasks).status == 'ready')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_SaveButton, {
                                        label: "New Task",
                                        icon: "fa-plus",
                                        onClick: _cache[0] || (_cache[0] = ($event) => (createTaskModalActive.value = true))
                                    })
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _hoisted_6,
                        (_ctx.allowShowAll)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                _createElementVNode("ul", _hoisted_8, [
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'MINE' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[1] || (_cache[1] = ($event) => (activeCategory.value = 'MINE'))
                                        }, "Assigned To Me")
                                    ], 2),
                                    _createElementVNode("li", {
                                        class: _normalizeClass({ 'is-active': activeCategory.value == 'ALL' })
                                    }, [
                                        _createElementVNode("a", {
                                            onClick: _cache[2] || (_cache[2] = ($event) => (activeCategory.value = 'ALL'))
                                        }, "All")
                                    ], 2)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_unref(tasks).status == 'loading')
                        ? (_openBlock(), _createBlock(_component_LoadingSpinner, { key: 0 }))
                        : (_unref(tasks).status == 'ready')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("div", {
                                    class: "columns is-mobile",
                                    ref_key: "itemListingWrapper",
                                    ref: itemListingWrapper
                                }, [
                                    _createElementVNode("div", _hoisted_10, [
                                        _hoisted_11,
                                        _createElementVNode("div", _hoisted_12, [
                                            (openTasks.value.length == 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_13, "No Open Tasks"))
                                                : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(openTasks.value, (task) => {
                                                var _a;
                                                return (_openBlock(), _createBlock(TaskWidget, {
                                                    key: task.id,
                                                    task: task,
                                                    highlighted: task.id == ((_a = highlightedTask.value) === null || _a === void 0 ? void 0 : _a.id),
                                                    onClick: ($event) => (highlightTask(task, $event.target))
                                                }, null, 8, ["task", "highlighted", "onClick"]));
                                            }), 128))
                                        ]),
                                        _hoisted_14,
                                        _createElementVNode("div", _hoisted_15, [
                                            (completedTasks.value.length == 0)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, "No Completed Tasks"))
                                                : _createCommentVNode("", true),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(completedTasks.value, (task) => {
                                                var _a;
                                                return (_openBlock(), _createBlock(TaskWidget, {
                                                    key: task.id,
                                                    task: task,
                                                    highlighted: task.id == ((_a = highlightedTask.value) === null || _a === void 0 ? void 0 : _a.id),
                                                    onClick: ($event) => (highlightTask(task, $event.target))
                                                }, null, 8, ["task", "highlighted", "onClick"]));
                                            }), 128))
                                        ])
                                    ]),
                                    (openTasks.value.length + completedTasks.value.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                            (highlightedTask.value == null)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_20))
                                                : (_openBlock(), _createElementBlock("div", {
                                                    key: 1,
                                                    style: _normalizeStyle({ 'padding-top': `${detailOffset.value}px` }),
                                                    class: "pb-3"
                                                }, [
                                                    (_openBlock(), _createBlock(TaskDetailPanel, {
                                                        task: highlightedTask.value,
                                                        key: highlightedTask.value.id,
                                                        showEntityLink: _ctx.showEntityLink,
                                                        onTaskUpdated: _cache[3] || (_cache[3] = ($event) => (onTaskUpdated($event)))
                                                    }, null, 8, ["task", "showEntityLink"]))
                                                ], 4))
                                        ]))
                                        : _createCommentVNode("", true)
                                ], 512)
                            ]))
                            : _createCommentVNode("", true)
                ]),
                _createVNode(_component_ModalDialog, {
                    active: createTaskModalActive.value,
                    title: "Add Task",
                    "allow-close": true,
                    onClose: _cache[6] || (_cache[6] = ($event) => (createTaskModalActive.value = false)),
                    "first-button-text": "Go Back",
                    "first-button-severity": "link",
                    onFirstbuttonselected: _cache[7] || (_cache[7] = ($event) => (createTaskModalActive.value = false)),
                    "second-button-text": "Add",
                    "second-button-severity": "primary",
                    onSecondbuttonselected: _cache[8] || (_cache[8] = ($event) => (onAddTaskClicked())),
                    loading: inProgressAction.value == 'addTask'
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_21, [
                                _createVNode(_component_FormSelectField, {
                                    label: "Assign To",
                                    modelValue: newTaskAudience.value,
                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((newTaskAudience).value = $event)),
                                    options: audienceTypes,
                                    disabled: inProgressAction.value == 'addTask'
                                }, null, 8, ["modelValue", "disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                    _hoisted_24,
                                    _withDirectives(_createElementVNode("textarea", {
                                        class: "textarea",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((newTaskText).value = $event)),
                                        disabled: inProgressAction.value == 'addTask'
                                    }, null, 8, _hoisted_25), [
                                        [_vModelText, newTaskText.value]
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                }, 8, ["active", "loading"])
            ], 64));
        };
    }
});
